import { render, staticRenderFns } from "./MineralFertilizerDetails.vue?vue&type=template&id=505ce6b2&scoped=true&lang=html&"
import script from "./MineralFertilizerDetails.vue?vue&type=script&lang=js&"
export * from "./MineralFertilizerDetails.vue?vue&type=script&lang=js&"
import style0 from "./MineralFertilizerDetails.vue?vue&type=style&index=0&id=505ce6b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505ce6b2",
  null
  
)

export default component.exports